<template>
  <div class="c-tempty-data">
    <i :class="'one ' + 'one-' + icon + ' ' + icon" />
    <span class="c-tempty-data-info">
      {{ info }}
      <slot name="info" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'EmptyData',
  props: {
    icon: {
      type: String,
      default: 'search'
    },
    info: {
      type: String,
      default: '暂无搜索结果'
    }
  }
}
</script>

<style lang="stylus">
.c-tempty-data
  margin-top 15vh !important
  text-align center
  color #9b9b9b
  display flex
  flex-direction column
  .one
    margin 0 auto
    display flex
    font-size 100px
    color #eaeaea
    height 100px
    &.search
      font-size 60px
      height 60px
  &-info
    max-width 100%
    margin-top 10px
    word-break break-all
</style>
